import { AxiosResponse } from 'axios';
import { createInjectable } from '@shared/utils/dependency';

export const HttpDependency = createInjectable({
	getIsVip() {
		return {
			isVIP: false,
			isPremiumVIP: false,
		};
	},

	hasCredits(_type?: 'generate' | 'optimize') {
		return false as boolean;
	},

	clearUserInfo() {},
	registerTrackManage() {},
	nonBusinessEventTracker(_res: AxiosResponse<any, any>) {},
	generateCallback() {},
	trackerOptimize(_data: any) {},
	blackListHandle() {}
});